// Lightweight Google Maps JS (Places) loader — shared, idempotent.
const KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY!;

declare global {
  interface Window {
    google: any;
    _gmReady?: boolean;
    _gmCbs?: (() => void)[];
    __gmLoaded?: () => void;
  }
}

export function loadGoogleMaps(cb: () => void) {
  if (typeof window === 'undefined') return;
  if (window.google?.maps?.places) { cb(); return; }
  window._gmCbs = window._gmCbs || [];
  window._gmCbs.push(cb);
  if (document.querySelector('script[data-gm]')) return; // already loading
  window.__gmLoaded = () => {
    window._gmReady = true;
    (window._gmCbs || []).forEach(fn => { try { fn(); } catch {} });
    window._gmCbs = [];
  };
  const s = document.createElement('script');
  s.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&libraries=places&language=he&region=IL&callback=__gmLoaded&loading=async`;
  s.async = true; s.defer = true; s.dataset.gm = '1';
  document.head.appendChild(s);
}
